module.exports = __webpack_public_path__ + "img/stoerer2.6d9d75b2.png";